
document.addEventListener('DOMContentLoaded', function () {
  setTimeout(() => {
    const cartDrawer = document.querySelector('.cart-drawer');
    cartDrawer.classList.remove('hidden');
  }, 1200);
});


function openCartDrawer() {
  document.querySelector(".cart-drawer").classList.add("cart-drawer--active");
}

function closeCartDrawer() {
  document
    .querySelector(".cart-drawer")
    .classList.remove("cart-drawer--active");
}

function updateCartItemCounts(count) {
  document.querySelectorAll(".cart-count").forEach((el) => {
    el.textContent = count;
  });
}

async function updateCartDrawer() {
  const res = await fetch("/?section_id=cart-drawer");
  await res.text().then(text => {
    const html = document.createElement("div");
    html.innerHTML = text;

    const newBox = html.querySelector(".cart-drawer").innerHTML;

    document.querySelector(".cart-drawer").innerHTML = newBox;

    addCartDrawerListeners();
    giftBagListener();
    cartDrawerFormSearch();
    renderSlider();
    return;
  });

}

function updateCartItemCounts(count) {
  document.querySelectorAll(".cart-count").forEach((el) => {
    el.textContent = count;
  });
  updateCountBubble(count);
}

function renderSlider(){
  
    new Swiper('.upsell-slider', {
      slidesPerView: 1, 
      spaceBetween: 10,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        768: { slidesPerView: 1 }, 
        1024: { slidesPerView: 1 }, 
      },
    });
  }

document.addEventListener("DOMContentLoaded", function () {
  renderSlider();
});

function updateCountBubble(n) {
  const cartCountBubble = document.querySelector('.cart-count-bubble');
  const cartIcon = document.querySelector("#cart-icon-bubble");

  // Si n es 0, elimina la burbuja si existe y sal de la función
  if (n === 0) {
    if (cartCountBubble) {
      cartCountBubble.remove();
      cartIcon.classList.add("empty")
    }
    return;
  } else {
    cartIcon.classList.remove("empty")
  }

  if (cartCountBubble) {
    // Actualiza el número en la burbuja existente
    const countText = cartCountBubble.querySelector('.pt-1');
    if (countText) {
      countText.innerText = n;
    }
  } else {
    // Crea y agrega una nueva burbuja si no existe
    const headerIcon = document.querySelector(".header__icon.link.link--text.focus-inset.relative");
    if (headerIcon) {
      const newBubble = document.createElement("div");
      newBubble.className = "cart-count-bubble";
      newBubble.innerHTML = `<span aria-hidden="true" class="pt-1">${n}</span>`;
      headerIcon.appendChild(newBubble);
    }
  }
}


function addCartDrawerListeners() {
  // Update quantities
  document.querySelectorAll(".cart-drawer-quantity-selector button").forEach((button) => {
    button.addEventListener("click", async () => {
      // Get line item key
      const rootItem =
        button.parentElement.parentElement.parentElement.parentElement
          .parentElement;
      const key = rootItem.getAttribute("data-line-item-key");

      // Get new quantity
      const currentQuantity = Number(
        button.parentElement.querySelector("input").value
      );
      const isUp = button.classList.contains(
        "cart-drawer-quantity-selector-plus"
      );
      const isZero = button.classList.contains(
        "remove-item"
      );
      let newQuantity = isUp ? currentQuantity + 1 : currentQuantity - 1;
      newQuantity = isZero ? 0 : newQuantity;

      // Ajax update\
      const res = await fetch("/cart/update.js", {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ updates: { [key]: newQuantity } }),
      });
      const cart = await res.json();

      updateCartItemCounts(cart.item_count);

      // Update cart
      updateCartDrawer();
    });
  });

  document.querySelector(".cart-drawer-box").addEventListener("click", (e) => {
    e.stopPropagation();
  });

  document
    .querySelectorAll(".cart-drawer-header-right-close, .cart-drawer")
    .forEach((el) => {
      el.addEventListener("click", () => {
        console.log("closing drawer");
        closeCartDrawer();
      });
    });
}

addCartDrawerListeners();



function cartDrawerFormSearch() {
  document.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
    form.addEventListener("submit", async (e) => {

      e.preventDefault();
      // Submit form with ajax
      await fetch("/cart/add", {
        method: "post",
        body: new FormData(form),
      });

      // Get cart count
      const res = await fetch("/cart.js");
      const cart = await res.json();
      updateCartItemCounts(cart.item_count);

      // Update cart
      await updateCartDrawer();

      // Open cart drawer
      openCartDrawer();
    });
  });
}
cartDrawerFormSearch();





document.querySelectorAll('a[href="/cart"]').forEach((a) => {
  a.addEventListener("click", (e) => {
    e.preventDefault();
    openCartDrawer();
  });
});


// modal 

function toggleModal(modalId) {
  const modal = document.getElementById(modalId);
  if (modal.classList.contains('hidden')) {
    modal.classList.remove('hidden');
    modal.style.display = 'flex';
  } else {
    modal.classList.add('hidden');
    modal.style.display = 'none';
  }
}



// gift bag logic


function giftBagListener() {
  const bagWithMessage = document.querySelector('.cart-drawer-box #giftWrapCheckbox');
  const multipleBag = document.querySelector('.cart-drawer-box #giftBagCheckbox');

  const disableCheckoboxes = () => {
    [bagWithMessage, multipleBag].map(checkbox => {
      checkbox.disabled = true;
      return;
    })
  }

  const bagWithMessageProductId = bagWithMessage.dataset.bagId;
  const multipleBagProductIds = multipleBag.dataset.bagIds.split(",");

  bagWithMessage.addEventListener("change", async (e) => {
    disableCheckoboxes();
    const checkbox = e.target;
    //const productId = checkbox.dataset.bagId;
    if (!checkbox.checked) {

      await fetch("/cart/update.js", {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ updates: { [bagWithMessageProductId]: 0 }, attributes: { gift_wrap: null } }),
      }).then(response => {
        updateCartDrawer();

      });
    } else {


      const updates = multipleBagProductIds.reduce((acc, productId) => {
        acc[productId] = 0;
        return acc;
      }, {});

      await fetch("/cart/add.js", {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          'items': [{
            'id': bagWithMessageProductId,
            'quantity': 1
          }], attributes: { gift_wrap: "whole" }
        }),
      }).then(async response => {
        await fetch("/cart/update.js", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            updates
          }),
        }).then(async response => {
          await updateCartDrawer().then(response => {
            toggleModal('giftWrapModal');
            giftMessageAttr();
          })
        });

      });
    }
  });

  const giftMessageAttr = () => {
    const giftMessageForm = document.querySelector("#giftMessage");
    giftMessageForm.addEventListener("submit", async e => {
      e.preventDefault();
      const data = new FormData(e.target);
      const formDataObject = Object.fromEntries(data.entries());
      const note = Object.entries(formDataObject).map(([key, value]) => `${key.toUpperCase()}: ${value || ''}`).join("\n");

      await fetch("/cart/update.js", {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ attributes: formDataObject,note }),
      }).then(response => {
        toggleModal('giftWrapModal');

      });
    });

  }

  multipleBag.addEventListener("change", async (e) => {

    disableCheckoboxes();
    const checkbox = e.target;

    if (!checkbox.checked) {
      const updates = multipleBagProductIds.reduce((acc, productId) => {
        acc[productId] = 0;
        return acc;
      }, {});

      await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          updates,
          attributes: { gift_wrap: null },
        }),
      }).then(response => {
        updateCartDrawer();
      });
    } else {

      await fetch("/cart/add.js", {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          'items': [{
            'id': multipleBagProductIds[0],
            'quantity': 1
          }], attributes: { gift_wrap: "multiple" }
        }),
      }).then(async response => {

        await fetch("/cart/update.js", {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates: { [bagWithMessageProductId]: 0 } }),
        }).then(async response => {
          await updateCartDrawer().then(response => {
            toggleModal('giftBagModal');
            cartDrawerFormSearch();
          })
        });
      });

    }
  });

}


giftBagListener();